export default {
  appTitle: 'Web Mobile - Grandjean Fils SA - La Deléje',
  imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}
